import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryPackageBundleCreationView } from "src/components/views/erp/delivery/deliveryPackageBundle/DeliveryPackageBundleCreationView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/project/delivery/bundling")({
	staticData: { title: i18n.t("delivery.package_bundling"), legacyViewKey: "projectDeliveryPackageBundlingPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryPackageBundleCreationView sourceType={"PROJECT"} />;
}
